import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import * as routes from '@educabot/educablocks-cosmos'
import * as creabotsSlice from '@sections/creabots/features/creabotsSlice'
import EmptyStateIcon from "@assets/icons/emptyStateIcon"
import styles from './emptyState.mod.scss'

const EmptyState = () => {
  const intl = useIntl()
  const { kits } = useSelector(creabotsSlice.selectCreabots)

  const handleGoHome = () => {
    window.location.href = `${routes.bloquesUri}/kits/creabots/${kits.selected.urlName}`
  }

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <EmptyStateIcon style={{ width: 190, height: 'auto' }} />
      </div>
      <div className={styles.content}>
        <div className={styles.texts}>
          <h2 className={styles.title}>{intl.formatMessage({ id: 'emptyState.title' })}</h2>
          <p className={styles.description}>{intl.formatMessage({ id: 'emptyState.description' })}</p>
        </div>
        <button className={styles.button} onClick={handleGoHome}>{intl.formatMessage({ id: 'emptyState.button' })}</button>
      </div>
    </div>
  )
}

export default EmptyState